import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/dat-tokens.css';
import { AllCommunityModule, ModuleRegistry, CsvExportModule } from 'ag-grid-community';
import { ToastContainer } from 'react-toastify';
ModuleRegistry.registerModules([AllCommunityModule, CsvExportModule]);
const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode tạm thời tắt: ag-grid 33 + React 19 bị lỗi
// "Cannot read properties of null (reading 'getColDef')" do double-mount.
root.render(
  <>
    <ToastContainer />
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
